<!--
 * @Author: DT
 * @Date: 2023-02-20 11:36:14
 * @LastEditors: ailin
 * @LastEditTime: 2025-07-02 11:23:38
 * @Description: file content
 * @FilePath: /yxdcommunity/src/components/ylsq/shareButton.vue
-->

<template>
  <div @click="handleShare" :class="{ is_width: isWidth }" :data-stat="'接龙分享_' + activityId">
    <slot name="button"></slot>
  </div>
</template>

<script>
import { getShareURL, queryXcxItemByActId } from "@/libs/api.js";
import { uleUrl, getCookie } from "@/libs/common";
export default {
  name: "editGroup",

  props: {
    shareName: {
      type: String,
      default: () => "",
    },
    activityId: {
      type: String,
      default: () => "",
    },
    shareImg: {
      type: String,
      default: () => "",
    },
    isWidth: {
      type: Boolean,
      default: () => false,
    },
    union_id: {
      type: String,
      default: () => "",
    },
    union_ref:{
      type: String,
      default: () => "",
    }
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    getUrlDomain() {
      //获取当前页面url的域名值，例如：https://h5.ule.com要获取到h5,https://h2.ule.com要获取到h2,https://h1.ule.com要获取到h1
      let url = window.location.href;
      return url.split(".")[0];
    },
    handleShare() {
      let data = {
        shareName: this.shareName,
        clientCallType: "H5",
        shareType: "59",
        // shareLink: `https://h1.${this.$uleUrl()}/yxd/community/chains/chainsDetail/${this.activityId}`,
        shareLink: `${this.getUrlDomain()}.${this.$uleUrl()}/yxd/community/chains/chainsDetail/${this.activityId}`,//王珏明要求改为h5域名
        unionRef: this.activityId,
      };
      if(this.union_id && this.union_ref){
        data.shareLink +=`?union_id=${this.union_id}&union_ref=${this.union_ref}`
      }
      console.log("分享====", data);
      this.$emit("toggle", false, "middle");
      getShareURL(data).then((res) => {
        let shareData = res.data;
        console.log("shareData====", shareData);
        let MinType = 0;
        console.log("uleUrl()===", uleUrl());
        console.log("uleUrl()===1", uleUrl().indexOf("testing") > -1);
        console.log("uleUrl()===2", uleUrl().indexOf("beta"));
        if (uleUrl().indexOf("testing") > -1 || uleUrl().indexOf("beta") > -1) {
          MinType = 2;
        }
        let query = `YXJLZDYZTD_${this.activityId}/${shareData.storeId}/${shareData.shareId}`;
        let qrUrl = `https://service.${uleUrl()}/weixin/miniwx/getqrcode?scene=${query}&page=packageA/solitaire/index`;
        console.log("qrUrl===", qrUrl);
        queryXcxItemByActId(this.activityId).then((ele) => {
          let chainsDetail = "";
          let chainsList = ele.data.xcxItemVOList,
            shareContent = "",
            shareImg = "",
            sharePrice = "",
            salePriceList = [];
          if (ele.data.activityDesc) {
            chainsDetail = JSON.parse(ele.data.activityDesc) || [];
            chainsDetail.forEach((item) => {
              if (item.desc) {
                shareContent = item.desc || "";
              }
            });
          }
          chainsList.forEach((item) => {
            if (item.imgUrl) {
              item.imgUrl = item.imgUrl.split("|*|")[0];
              item.imgUrl = item.imgUrl.replace("http://", "https://");
              item.imgLarge = item.imgUrl;
              if (!/_l\.jpg/.test(item.imgUrl)) {
                item.imgUrl = item.imgUrl.replace(".jpg", "_l.jpg");
              }
            }
            salePriceList.push(item.salPrice);
          });
          // salePriceList = ['999','998','10.0','10.0','999','10.0','11.00']
          console.log("salePriceList==11=", salePriceList);
          if (salePriceList.length > 1) {
            salePriceList.sort(function(a, b) {
              if (a > b) {
                return 1;
              } else {
                return -1;
              }
            });
            console.log("sort===", salePriceList);
            if (salePriceList[0] == salePriceList[salePriceList.length - 1]) {
              sharePrice = Number(salePriceList[0]).toFixed(2);
            } else {
              sharePrice = `${Number(salePriceList[0]).toFixed(2)}-${Number(salePriceList[salePriceList.length - 1]).toFixed(2)}`;
            }
          } else {
            sharePrice = Number(salePriceList[0]).toFixed(2);
          }
          if (chainsList.length > 0) {
            shareImg = chainsList[0].imgUrl;
          }
          if (ele.data.shareImgUrl) {
            shareImg = ele.data.shareImgUrl;
          }
          let baseData = {
            listName: this.shareName,
            listImage: [shareImg],
            shareCommission: 0,
            shareTitle: this.shareName,
            shareContent: shareContent,
            WXMiniProgram_Type: MinType, // 0正式版，1测试版 2体验版
            WXMiniProgram_DialogName: "微信好友",
            WXMiniProgram_userName: "gh_1e6276474cf7",
            WXMiniProgram_Title: this.shareName,
            WXMiniProgram_pageUrl: shareData.shareUrl3,
            // WXMiniProgram_path: "pages/index/index?targetUrl=" + encodeURIComponent(shareData.shareUrl3),
            WXMiniProgram_path: "packageA/solitaire/index?targetUrl=" + encodeURIComponent(shareData.shareUrl3),
            // WXMiniProgram_path: `packageA/solitaire/index?activityCode=${this.activityId}&shareId=${shareData.shareId || ''}&storeid=${shareData.storeId || ''}&targetUrl=app_ylxdsq`,
            WXMiniProgram_OriginalId: "gh_1e6276474cf7",
            WXMiniProgram_image: shareImg,
            canShareOkCallBack: true,
            ruleDescription: "",
            imageBanner: shareImg,
            miniwx_qrcode_url: qrUrl,
            yxJlCopyUrl: `${this.shareName} ${shareData.shareUrl4}`,
          };
          let shareObj = this.objectassign({}, baseData, shareData, {
            listId: this.activityId,
            sharePrice: sharePrice,
            marketPrice: sharePrice,
            shareFrom: "0",
          });
          // shareObj.shareOptions = "4##10##5";
          // shareObj.shareOptions = "4##10##0##1##5";
          // shareObj.shareOptions = "4##1##10##5##7";
          shareObj.shareOptions = "4##1##10##5";
          // shareObj.shareOptionsIndex = "4##1##10##5";
          shareObj.shareUrl = shareObj.shareUrl4 || shareObj.shareUrl3;
          let orgCode = getCookie("lowestOrgCode") || 100;
          console.log("ele===", ele.data.transport);
          if (orgCode != 58093 && ele.data.transport != 2) {
            console.log("指定自提点");
            shareObj.isAppoint = true;
          } else {
            shareObj.isAppoint = false;
          }
          console.log("app弹出分享参数", shareObj);
          if (window.dsBridge) {
            window.dsBridge.call("generalAction", {
              type: "2",
              ios_action: JSON.stringify(shareObj),
              android_action: JSON.stringify(shareObj),
              maxversion: "999&999",
              needlogin: "false",
            });
          } else {
            window.location.href =
              "uleMobile://uleShare_" + encodeURI(shareObj.shareTitle) + "##" + encodeURI(shareObj.shareContent) + "##" + shareObj.listImage + "##" + shareObj.shareUrl + "##" + shareObj.shareContent;
          }
        });
      });
    },
  },
  created() {},
  mounted() {},
};
</script>

<style scoped lang="scss">
.is_width {
  width: 100%;
}
</style>
